const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')     // Substitui espaços por hífens
    .replace(/[^\w\s-]/g, '') // Remove caracteres especiais (mantém letras, números, espaços e hífens)
    .replace(/\s+/g, '-')     // Substitui novamente espaços por hífens (após remover especiais)
    .replace(/--+/g, '-')    // Substitui múltiplos hífens por um único hífen
    .replace(/^-+/, '')      // Remove hífens do início
    .replace(/-+$/, '');      // Remove hífens do final
};

export default slugify;